import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { type LibraryBook, readingStreak } from '@/lib/insights'
import { InsightCard } from './InsightCard'

/** Consecutive months with at least one finished book */
export function ReadingStreakCard({ books }: { books: LibraryBook[] }) {
  const { t } = useTranslation()
  const streak = useMemo(() => readingStreak(books), [books])

  return (
    <InsightCard icon="🔥" title={t('insights.streak.title')}>
      <div className="space-y-2">
        <p className="text-2xl font-bold text-foreground">
          {t('insights.streak.months', { count: streak.current })}
        </p>
        <p className="text-xs text-muted-foreground">
          {streak.current === 0
            ? t('insights.streak.start')
            : streak.activeThisMonth
              ? t('insights.streak.active')
              : t('insights.streak.keepAlive')}
        </p>
        {streak.longest > 0 && (
          <p className="text-xs text-muted-foreground">
            {t('insights.streak.longest', { count: streak.longest })}
          </p>
        )}
      </div>
    </InsightCard>
  )
}
